import React from "react";

const Dereference = () => {
  return (
    <div>
      <h1>Dereference Component</h1>
      <p>Content for Dereference goes here...</p>
    </div>
  );
};

export default Dereference;
